var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import classNames from 'classnames';
import produce from 'immer';
import React, { useEffect, useState } from 'react';
import { useToast } from '~/components_to_be_packaged/toast/provider';
import { useWorkspaceFolder } from '~/routes/projects_workspace/provider';
import { MetadataFieldNames } from '~/types/common';
import getDateFromISOToLocal from '~/utils/getDateFromISOToLocal';
import { useComparisonGrid, } from '../provider';
import ComparisonConfirmation from './comparison_confirmation';
var ModalTypes;
(function (ModalTypes) {
    ModalTypes["ARCHIVE"] = "archive";
    ModalTypes["REMOVE"] = "remove";
})(ModalTypes || (ModalTypes = {}));
export const ActionControls = () => {
    var _a, _b;
    const [visibleModal, setVisibleModal] = useState(null);
    const { showToast } = useToast();
    const { comparisonDetails, deleteComparisons, setComparisonDetails, updateComparisons, } = useWorkspaceFolder();
    const { gridRef, gridData } = useComparisonGrid();
    const selectedRows = (_b = (_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.api.getSelectedNodes()) === null || _b === void 0 ? void 0 : _b.map(d => d.data);
    const isSelectedRowArchived = selectedRows.length ? selectedRows[0].isArchived : false;
    const getSelectedProjectsName = () => {
        const comparisonsNames = selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.map(row => (getDateFromISOToLocal(row.createdAt, { month: 'short', day: '2-digit' }) + ' ' +
            row.documents.map(md => { var _a; return (_a = md.find(f => f.name === MetadataFieldNames.filename)) === null || _a === void 0 ? void 0 : _a.value; })
                .join(', ')));
        return comparisonsNames;
    };
    useEffect(() => {
        var _a, _b;
        if (selectedRows.length === 1) {
            const newComparisons = produce(gridData, (draft) => {
                if (!(draft === null || draft === void 0 ? void 0 : draft.length))
                    return [];
                for (const comparison of draft) {
                    comparison.isSelectable = comparison.isArchived === isSelectedRowArchived;
                }
            });
            (_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.api.applyTransaction({ update: newComparisons });
        }
        const gridApi = (_b = gridRef.current) === null || _b === void 0 ? void 0 : _b.api;
        return () => {
            const newComparisons = produce(gridData, (draft) => {
                if (!(draft === null || draft === void 0 ? void 0 : draft.length))
                    return [];
                for (const comparison of draft) {
                    comparison.isSelectable = true;
                }
            });
            gridApi === null || gridApi === void 0 ? void 0 : gridApi.applyTransaction({ update: newComparisons });
        };
    }, [gridData, isSelectedRowArchived, selectedRows]);
    const handleDeleteComparisons = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const selectedRows = (_b = (_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.api.getSelectedNodes()) === null || _b === void 0 ? void 0 : _b.map(d => d.data);
        if (!(selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length))
            return;
        const newRows = comparisonDetails === null || comparisonDetails === void 0 ? void 0 : comparisonDetails.filter(c => !selectedRows.some(n => n.projectDocumentComparisonId === c.projectDocumentComparisonId));
        setComparisonDetails(newRows !== null && newRows !== void 0 ? newRows : null);
        yield deleteComparisons(selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.map(c => c === null || c === void 0 ? void 0 : c.projectDocumentComparisonId));
        showToast({
            description: 'Comparison removed',
        });
    });
    const archiveIcon = classNames('fa-solid', {
        'fa-box-archive': !isSelectedRowArchived,
        'fa-trash-undo': isSelectedRowArchived,
    });
    const archiveText = !isSelectedRowArchived ? 'Archived' : 'Unarchive';
    const handleArchiveComparisons = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const selectedRows = (_b = (_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.api.getSelectedNodes()) === null || _b === void 0 ? void 0 : _b.map(d => d.data);
        (_c = gridRef.current) === null || _c === void 0 ? void 0 : _c.api.deselectAll();
        if (!(selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length))
            return;
        const archivedComparisons = produce(selectedRows, (draft) => {
            draft === null || draft === void 0 ? void 0 : draft.forEach(c => { c.isArchived = !isSelectedRowArchived; });
        });
        const newComparisons = produce(comparisonDetails, (draft) => {
            if (!(draft === null || draft === void 0 ? void 0 : draft.length))
                return [];
            for (const comparison of draft.filter(c => selectedRows.some(n => n.projectDocumentComparisonId === c.projectDocumentComparisonId))) {
                comparison.isArchived = !isSelectedRowArchived;
            }
        });
        setComparisonDetails(newComparisons);
        yield updateComparisons(archivedComparisons !== null && archivedComparisons !== void 0 ? archivedComparisons : []);
        showToast({
            description: `Comparison(s) ${archiveText}d`,
        });
    });
    return (React.createElement("div", { className: 'comparison-action-wrapper' },
        React.createElement("div", { className: 'comparison-action', onClick: () => setVisibleModal(ModalTypes.REMOVE) },
            React.createElement("i", { className: "fa-solid fa-trash-can" }),
            React.createElement("span", { className: 'action-text' }, "Remove")),
        React.createElement(ComparisonConfirmation, { isVisible: visibleModal === ModalTypes.REMOVE, onHide: () => setVisibleModal(null), handleClick: handleDeleteComparisons, comparisonNames: getSelectedProjectsName(), message: 'Are you sure you want to remove the following comparison(s)?', buttonText: 'Remove' }),
        React.createElement("div", { className: 'comparison-action', onClick: () => setVisibleModal(ModalTypes.ARCHIVE) },
            React.createElement("i", { className: archiveIcon }),
            React.createElement("span", { className: 'action-text' }, archiveText)),
        React.createElement(ComparisonConfirmation, { isVisible: visibleModal === ModalTypes.ARCHIVE, onHide: () => setVisibleModal(null), handleClick: handleArchiveComparisons, comparisonNames: getSelectedProjectsName(), message: `Are you sure you want to ${archiveText} the following comparison(s)?`, buttonText: archiveText })));
};
